import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { VisualReportAccessService } from '../services/visual-report-access.service';

@Component({
  selector: 'app-visual-report-upgrade',
  imports: [A11yModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '(document:keydown.escape)': 'access.close()' },
  template: `
    @if (access.upgradeOpen()) {
      <div class="upgrade-backdrop" (click)="access.close()">
        <section role="dialog" aria-modal="true" aria-labelledby="visual-upgrade-title"
          aria-describedby="visual-upgrade-description" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
          (click)="$event.stopPropagation()">
          <button class="close" type="button" aria-label="Close Visual Reports upgrade" cdkFocusInitial (click)="access.close()">×</button>
          <span class="eyebrow">VISUAL REPORTS</span>
          <h2 id="visual-upgrade-title">Visual Reports requires a paid upgrade</h2>
          <p id="visual-upgrade-description">Turn assessment results into clear, engaging visual reports. Create reusable templates and customize reports for each client.</p>
          <ul class="features" aria-label="Visual Reports features">
            <li><strong>Reusable templates</strong><span>Save your layouts and questions to use across clients.</span></li>
            <li><strong>Answers from your report</strong><span>Generate content guided by your questions and the client's report.</span></li>
            <li><strong>Clear assessment charts</strong><span>Turn test results into visuals that are easier to understand.</span></li>
            <li><strong>Flexible layouts</strong><span>Arrange text, images, and cards. Customize colors, fonts, and spacing.</span></li>
            <li><strong>Present and print</strong><span>Walk through reports with clients, print them, or save them as a PDF.</span></li>
          </ul>
          <footer><a href="mailto:support@reverbreports.com?subject=Visual%20Reports%20upgrade" target="_blank" rel="noopener noreferrer">Contact us</a></footer>
        </section>
      </div>
    }
  `,
  styles: [`
    .upgrade-backdrop{position:fixed;inset:0;z-index:1100;display:grid;place-items:center;padding:24px;background:#152d2966;backdrop-filter:blur(4px)}
    section{position:relative;box-sizing:border-box;width:min(620px,100%);max-height:90dvh;overflow:auto;background:#fff;border:1px solid #dce7e1;border-radius:20px;padding:32px;color:#203b32;box-shadow:0 24px 80px #102f2933}
    .close{position:absolute;right:14px;top:10px;border:0;background:transparent;font-size:28px;cursor:pointer;padding:8px;color:inherit}
    .eyebrow{font-size:11px;font-weight:700;letter-spacing:.15em;color:#547565}h2{font-size:26px;line-height:1.2;margin:14px 20px 14px 0}p{line-height:1.6;color:#586b62}
    .features{margin:24px 0;padding:20px 20px 20px 40px;border-radius:12px;background:#eef5ed;display:grid;gap:16px}
    .features li{padding-left:4px;line-height:1.5}.features li::marker{color:#275d48}.features strong,.features span{display:block}.features span{margin-top:2px;color:#586b62;font-size:14px}
    footer{display:flex;justify-content:flex-end}a{background:#275d48;color:white;padding:12px 24px;border-radius:8px;text-decoration:none;font-weight:600}button:focus-visible,a:focus-visible{outline:3px solid #74ad91;outline-offset:3px}
    @media(max-width:480px){section{padding:24px}h2{font-size:22px}.upgrade-backdrop{padding:12px}}
  `],
})
export class VisualReportUpgrade {
  readonly access = inject(VisualReportAccessService);
}
